// extracted by mini-css-extract-plugin
export default {"Controls":"j3u1sD9wnIEP3wDjlG6l","ButtonContainer":"ODSJc3N0ryEeD9eaQ2PW","Button":"iOjPB6F65AxLDfJWhAPD"};